import { Box } from '@chakra-ui/react';

// A progress bar on the accent's own tint (design): list progress,
// downloads.
export function ProgressBar({
  done,
  total,
  label,
  grow = false,
}: {
  done: number;
  total: number;
  label: string;
  /** Fill the rest of a row (checklist header). */
  grow?: boolean;
}) {
  const percent = total === 0 ? 0 : Math.round((done / total) * 100);
  return (
    <Box
      role="progressbar"
      aria-label={label}
      aria-valuenow={done}
      aria-valuemin={0}
      aria-valuemax={total}
      h="8px"
      borderRadius="4px"
      bg="accent.tint"
      overflow="hidden"
      flex={grow ? '1' : undefined}
      w={grow ? undefined : 'full'}
      flexShrink={0}
    >
      <Box
        h="full"
        w={`${percent}%`}
        borderRadius="4px"
        bg="accent"
        transition="width 0.3s"
      />
    </Box>
  );
}
